function random_int(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //최댓값은 제외, 최솟값은 포함
}
module.exports = class Variables {
    constructor() {
        this.variables = {}
    }

    getDatasInArgs(s) {
        let idx = -1
        let answer = ''
        for (let i = 0; i < s.length; i++) {
            if (s[i] === '[') idx = i + 1
            else if (s[i] === ']') {
                let tmp = this.variables[s.substring(idx-1, i+1)]
                if ((typeof tmp) != 'number') tmp = '\''+tmp+'\''
                answer += tmp
                idx = -1
            } else if (idx === -1) answer = answer + s[i]
        }
        return answer
    }

    gcd(a, b) {return b ? this.gcd(b, a % b) : Math.abs(a);}
    lcm(a, b) {return (a * b) / this.gcd(a, b);}
    getDivision(x) {
        let i = 1;
        let my_res = ''
        while (i<=x){
            if(x % i === 0) {
                my_res = my_res + i + ', '
                i++;
            }
            else i++;
        }
        return my_res.substring(0, my_res.length - 2);
    }
    getMultiply(y, x) {
        let i = 1;
        let my_res = ''
        while (i <= x){
            my_res = my_res + (i*y) + ', '
            i++;
        }
        return my_res.substring(0, my_res.length - 2);
    }
    getPrimefactor(x) {
        let my_res = ''; // 분해된 소수를 저장
        let divisor; // 제수
        let squareRoot;
        let mok, nmg; // 몫과 나머지
        do {
            divisor = 2;
            squareRoot = parseInt(Math.sqrt(x));
            do {
                if (divisor > squareRoot){
                    divisor = x;
                    break;
                }
                mok = parseInt(x/divisor);
                nmg = x - mok*divisor;
            }while(nmg != 0 && divisor++);
            my_res += divisor + ' x '
        }while(x != divisor && (x = mok));

        return my_res.substring(0, my_res.length - 3);
    }
    getDivisionRandom(x) {
        let i = 1;
        let my_res = []
        while (i<=x){
            if(x % i === 0) {
                my_res.push(i)
                i++;
            }
            else i++;
        }
        return my_res[Math.floor(Math.random() * my_res.length)]
    }
    getMultiplyRandom(y, x) {
        let i = 1;
        let my_res = []
        while (i*y<=x){
            my_res.push(i*y)
            i++;
        }
        return my_res[Math.floor(Math.random() * my_res.length)]
    }

    setFunction (label, type, args) {
        let res, tmp, condition
        args = args.replace(' ', '')
        args = this.getDatasInArgs(args)
        if (type === 'division' || type === 'primefactor')
            args = args + ','
        let a = args.split(',')[0]
        let b = args.split(',')[1]
        let x, comma_cnt = 0
        switch (type) {
            case 'division':
                res = this.getDivision(parseInt(a))
                break
            case 'primefactor':
                res = this.getPrimefactor(parseInt(a))
                break
            case 'multiply':
                res = this.getMultiply(parseInt(a), parseInt(b))
                break
            case 'division_random':
                res = this.getDivisionRandom(parseInt(a))
                break
            case 'multiply_random':
                res = this.getMultiplyRandom(parseInt(a), parseInt(b))
                break
            case 'random_int':
                res = random_int(a, b)
                break
            case 'random_int2':
                x = ''
                for (let i=0;i<args.length;i++) {
                    if (args[i] === ',') comma_cnt++;
                    if (comma_cnt >= 2) x += args[i];
                }
                x = x.split(',')
                for (let i=0;i<x.length;i++)
                    x[i] = parseInt(x[i])
                for (let i=0;i<30;i++) {
                    res = random_int(a, b)
                    if (x.includes(res)) continue
                    break
                }
                break
            case 'random_int_list':
                res = args.split(',')[Math.floor(Math.random() * args.split(',').length)]
                break
            case 'gcd':
                a = parseInt(a)
                b = parseInt(b)
                res = this.gcd(a, b)
                break
            case 'ceil':
                a = parseInt(a)
                res = Math.ceil(a)
                break
            case 'round':
                a = parseInt(a)
                res = Math.round(a)
                break
            case 'floor':
                a = parseInt(a)
                res = Math.floor(a)
                break
            case 'lcm':
                a = parseInt(a)
                b = parseInt(b)
                res = this.lcm(a, b)
                break
            case 'condition':
                condition = this.eval_script(a)
                if (condition) res = this.eval_script(args.split(',')[1])
                else res = this.eval_script(args.split(',')[2])
                break
            default:
                res = this.eval_script(args)
                tmp = res.toString()
                if (tmp.includes('.') && tmp.split('.')[1].includes('000')) {
                    tmp = tmp.split('.')[0] + '.' + tmp.split('.')[1].split('000')[0]
                    res = parseFloat(tmp)
                }
                if (tmp.includes('.') && tmp.split('.')[1].includes('999')) {
                    res = res.toFixed(tmp.split('.')[1].indexOf('999'))
                }
        }
        this.variables[label] = res
    }

    getLabel(s) {
        return this.variables[s]
    }

    eval_script(s) {
        s = s.toString()
        let key_array = Object.keys(this.variables)
        key_array.sort(function(a, b){
            return b.length - a.length;
        });
        for(let k of key_array)
            s = s.replace(k.replace('[', '').replace(']', ''), this.variables[k])
        s = s.replace('--', '+')
        return eval(s)
    }

    verifyDuplicateVars (cur_datas, tmp_datas) {
        let t1 = []
        for (let x of tmp_datas) if (x.type !== 'num') t1.push(x.text)
        t1 = JSON.stringify(t1)
        for (let x of cur_datas) {
            let t2 = []
            for (let y of x) if (y.type !== 'num') t2.push(y.text)
            if (JSON.stringify(t2) === t1)
                return false
        }
        return true
    }

    convert(data) {
        let num = 1
        data.data = JSON.parse(data.data)
        let my_datas = JSON.parse(JSON.stringify(data.data.datas))
        data.data.datas = []
        let duplicate_sw = false
        for (let i = 0; i < parseInt(data.data.num); i++) {
            let rand_cnt = 0
            for (;;) {
                let tmp_datas = JSON.parse(JSON.stringify(my_datas))
                for (let rect of tmp_datas) {
                    switch (rect.type) {
                        case 'num':
                            rect.text = num.toString() + '.'
                            num += 1
                            break;
                        case 'var':
                            this.setFunction(rect.label, rect.function, rect.text)
                            break;
                        case 'text':
                            if (rect.text.length > 0 && rect.text[0] === '[')
                                rect.text = this.getLabel(rect.text)
                            break;
                    }
                }
                if (this.verifyDuplicateVars(data.data.datas,tmp_datas)) {
                    data.data.datas.push(tmp_datas)
                    break
                } else num -= 1
                if (rand_cnt++ > 20) {
                    duplicate_sw = true
                    data.data.datas.push(tmp_datas)
                    num += 1
                    //alert('문제수가 너무 많아 중복 문제가 생성됩니다.')
                    break
                }
            }
        }
        if (duplicate_sw) alert('문제수가 너무 많아 중복 문제가 생성됩니다.')
        return data.data
    }
};